import { NumberInput } from 'ui-components/components/number-input';

import styles from './widget-properties.module.less';

import type { RequiredPropertyProps } from './types';

type NumberPropertyInputProps = RequiredPropertyProps<number | undefined> & {
  value: number;
};

export const NumberPropertyInput = ({ updateWidget, value, id }: NumberPropertyInputProps) => {
  return <NumberInput className={styles['input-range-property']} id={id} min={6} onChange={updateWidget} value={value} />;
};
